export enum FileExtensions {
  JPG = '.jpg',
}
export enum MimeTypes {
  ImageJpeg = 'image/jpeg',
  ImageTiff = 'image/tiff',
}
